import { ClientsService } from './../../../shared/services/clients.service';
import { SitesService } from './../../../shared/services/sites.service';
import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';

import { FormEditBaseComponent } from '@components/form-edit-base.component';
import { UiService } from '@services/ui.service';
import { Site } from '@classes/site';
import { Client } from '@classes/client';

interface CivilityItem { id: number; name: string; }

@Component({
  selector: 'app-site-edit',
  templateUrl: './site-edit.component.html',
  styleUrls: ['./site-edit.component.scss']
})
export class SiteEditComponent extends FormEditBaseComponent implements OnInit {
  @Input() site: Site;
  clients: Client[];
  identifierPattern = "^[0-9]{0,50}$";

  stringMaxLength = 50;

  constructor(
    protected uiSrv: UiService,
    protected fb: UntypedFormBuilder,
    private sitesSrv: SitesService,
    private clientsSrv: ClientsService
  ) {
    super(uiSrv, fb);
  }

  ngOnInit() {
    super.ngOnInit();
    this.initSub();
  }

  initSub(): void {
    this.isLoading = true;
    this.clientsSrv.getList().subscribe(clientsFromSrv => {
      this.clients = clientsFromSrv;
      this.isLoading = false;
      this.initForm();
    });
  }

  onSubmit(): void {
    this.isLoading = true;
    if (this.site) {
      this.update();
    } else {
      this.create();
    }
  }

  onCancel(): void {
    this.editFinished.emit();
  }

  endForm(response: boolean) {
    if (response) {
      this.onSubmit();
    } else {
      this.onCancel();
    }
  }

  private update(): void {
    const siteCopy: Site = JSON.parse(JSON.stringify(this.site));
    siteCopy.name = this.editForm.value.name;
    siteCopy.client = this.editForm.value.client;
    siteCopy.documentUrl = this.editForm.value.documentUrl;

    this.sitesSrv.put(siteCopy).subscribe(() => this.isLoading = false);
  }

  private create(): void {
    this.site = new Site(
      this.editForm.value.name,
      this.editForm.value.client,
      this.editForm.value.otherSite,
      this.editForm.value.documentUrl
    );

    this.sitesSrv.post(this.site)
      .subscribe(
        () => this.isLoading = false,
        () => this.site = null
      );
  }

  private initForm(): void {
    let name = "";
    let client = null;
    let otherSite = false;
    let documentUrl = '';

    if (this.site) {
      name = this.site.name;
      client = this.site.client || null;
      otherSite = this.site.otherSite;
      documentUrl = this.site.documentUrl;
    }

    this.editForm = this.fb.group({
      name: [name, [Validators.required, Validators.maxLength(this.stringMaxLength)]],
      client: [client, Validators.required],
      otherSite: [otherSite],
      documentUrl: [documentUrl]
    });
  }
}
